import React, { Component } from "react";
import { connect } from "react-redux";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

//Components
import LoginForm from "./../components/LoginForm";

//Deps
import { withStyles } from "@material-ui/core/styles";
import { push } from "react-router-redux";

function mapStateToProps(state) {
  return {
    isAuth: state.user.auth !== null,

    //Form Values
    email: state.forms.login.email,
    password: state.forms.login.password,
    dbErrors: state.forms.errors.hasErrors,

    //Form State
    pending: state.forms.forms.login.$form.pending,
    submitted: state.forms.forms.login.$form.submitted,
    submitFailed: state.forms.forms.login.$form.submitFailed,
    validating: state.forms.forms.login.$form.validating,

    emailIsValid: state.forms.forms.login.email.valid,
    formIsValid: state.forms.forms.login.$form.valid,
    passwordIsValid: state.forms.forms.login.password.valid,

    //Errors
    emailErrors: state.forms.forms.login.email.errors,
    formErrors: state.forms.forms.login.$form.errors,
    passwordErrors: state.forms.forms.login.password.errors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleSubmit: val =>
      dispatch({
        type: ACTIONS.SUBMIT_LOGIN,
        meta: {
          model: "forms.login",
          payload: val
        }
      }),

    resetPasswordDispatch: email => dispatch({ type: ACTIONS.RESET_PASSWORD, email: email }),

    //If already logged in
    routeToProfile: () => {
      dispatch(push("profile"));
    }
  };
}

//Styles
const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: "2em"
  }
});

class LoginPage extends Component {
  componentDidMount() {
    const { isAuth, routeToProfile } = this.props;
    return isAuth ? routeToProfile() : null;
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div>
          <h3 style={{ padding: "1em 0" }}>LOGIN</h3>
          <LoginForm model="forms.login" handleSubmit={this.props.handleSubmit} {...this.props} />
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(LoginPage));



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js